import _ from 'lodash'
import {
    TYPE_GOTO_NEXT,
    TYPE_GOTO_PREVIOUS,
    TYPE_GOTO_MENU,
    TYPE_GOTO_LOCATION,
    TYPE_TOGGLE_RESOURCES,
    TYPE_STATUS_COMPLETE,
    TYPE_SET_AUDIO,
    TYPE_SET_AUDIO_STATUS,
    TYPE_SET_AUDIO_EVENT,
    TYPE_SET_ALERT,
    TYPE_INITIALIZE_COURSE,
    TYPE_UPDATE_PAGE_STATUS
} from "../actions/course.action";


const initialState = {
    firstRun: true,
    lmsEnabled: false,
    debug: false,
    autoStart: false,
    audioData: null,
    audioStatus: null,
    audioEvent: null,
    alertData: null,
    pageStatus: [],
    pageLocked: false,
    resourcesVisible: false,
    resourcesSelection: null,
    resourcesPath: null,
    exitRequested: false,
    courseInitialized: false,
    courseLocation: [-1, -1],
    courseStatus: "not_started",
    courseData: {},
    currentPage: {}
};

const getNextLocation = (state) => {
    let l = [];
    let currentChapterPages = state.courseData.content[state.courseLocation[0]].pages;
    //if at end of chapter
    if (state.courseLocation[1] + 1 >= currentChapterPages.length) {
        //if at end of course
        if (state.courseData.navigationMode && state.courseData.navigationMode === "chapterBreak") {
            console.log(" chapter break")
            l = [-1, -1]
        } else if (state.courseLocation[0] + 1 >= state.courseData.content.length) {
            console.log("  at the end of the course")
            l = [-1, -1]
        } else {
            l = [Number(state.courseLocation[0] + 1), 0]
        }
    } else {
        l = [state.courseLocation[0], Number(state.courseLocation[1] + 1)]
    }
    return l;
}

const getPreviousLocation = (state) => {
    let l = [];
    //if at beginning of chapter
    if (state.courseLocation[1] - 1 < 0) {
        //if at beginning of course
        if (state.courseLocation[0] - 1 < 0) {

            l = [-1, -1];
        } else if (state.courseData.navigationMode && state.courseData.navigationMode === "chapterBreak") {
            l = [-1, -1];
        } else {
            let prevChapter = state.courseData.content[state.courseLocation[0] - 1];
            l = [state.courseLocation[0] - 1, prevChapter.pages.length - 1]
        }
    } else {
        l = [state.courseLocation[0], state.courseLocation[1] - 1]
    }
    return l;
}

const getPageLocked = (state, location) => {
    if (location[0] === -1) return false;
    var pstatus = (state.pageStatus.length === 0) ? 0 : state.pageStatus[location[0]][location[1]];
    if (pstatus === 2) return false;
    var page = state.courseData.content[location[0]].pages[location[1]];
    if ((page.elements.some((el) => el.required))) {
        return true;
    }
    return false;
}


const updateLocation = (state, location) => {
    //console.log("course.reducer updateLocation(", state, location + ")");
    let st = state.pageStatus.slice();
    if (location[0] === -1) return st;
    let p = st[location[0]][location[1]]
    if (p != 2) {
        if (getPageLocked(state, location)) {
            st[location[0]][location[1]] = 1;
        } else {
            st[location[0]][location[1]] = 2;
        }
    }
    return st;
}

const updateStatus = (state, status) => {
    let st = state.pageStatus.slice();
    if (state.courseLocation[0] === -1) return st;
    st[state.courseLocation[0]][state.courseLocation[1]] = status;
    return st;
}

const getPage = (state, location) =>{
    if(location.indexOf(-1)!==-1){
        return  null;
    }
    let p = state.courseData.content[location[0]].pages[location[1]]
    return p
}

const updateCourseStatus = (flatPageStatus) => {
    //console.log("course.reducer updateCourseStatus(",flatPageStatus,")");
    let cs = "not_started";
    let completed = true;
    for (let i = 0; i < flatPageStatus.length; i++) {
        if (flatPageStatus[i] !== 0) {
            cs = "started"
        }
        if (flatPageStatus[i] !== 2) {
            completed = false;
        }
    }
    if (completed) {
        cs = "completed"
    }
    return cs;
}


export default (state = initialState, action) => {
    switch (action.type) {
        case TYPE_INITIALIZE_COURSE:
            return {
                ...state,
                ...action.payload
            }
        case TYPE_GOTO_NEXT:
            let nloc = getNextLocation(state);
            let ps = updateLocation(state, nloc);
            let page = getPage(state,nloc)
            let stat = updateCourseStatus(_.flattenDeep(ps))
            return {
                ...state,
                courseLocation: nloc,
                pageStatus: ps,
                pageLocked: getPageLocked(state, nloc),
                courseStatus: stat,
                currentPage: page
            }
        case TYPE_GOTO_PREVIOUS:
            let ploc = getPreviousLocation(state);
            let p = getPage(state,ploc)
            return {
                ...state,
                courseLocation: ploc,
                pageStatus: updateLocation(state, ploc),
                pageLocked: getPageLocked(state, ploc),
                currentPage: p,
                alertData: null
            }
        case TYPE_GOTO_LOCATION:
            let pg = getPage(state,action.payload)
            let loc = updateLocation(state,action.payload);
            let lkd = getPageLocked(state,action.payload);
            return {
                ...state,
                courseLocation: action.payload,
                currentPage: pg,
                pageStatus: loc,
                pageLocked: lkd
            }
        case TYPE_GOTO_MENU:
            return {
                ...state,
                currentPage: null,
                courseLocation: [-1, -1]
            }
        case TYPE_STATUS_COMPLETE:
            let s = updateStatus(state, 2)
            let cs = updateCourseStatus(_.flattenDepth(s));
            return {
                ...state,
                pageStatus: s,
                courseStatus: cs,
                pageLocked: false
            }
        case TYPE_TOGGLE_RESOURCES:
            return {
                ...state,
                ...action.payload
            }
        case TYPE_SET_AUDIO:
            return {
                ...state,
                audioData: action.payload,
                audioStatus: null
            }
        case TYPE_SET_AUDIO_STATUS:
            return {
                ...state,
                audioStatus: action.payload
            }
        case TYPE_SET_AUDIO_EVENT:
            return {
                ...state,
                audioEvent: action.payload
            }
        case TYPE_SET_ALERT:
            return {
                ...state,
                alertData: action.payload
            }
        case TYPE_UPDATE_PAGE_STATUS:
            return {
                ...state,
                pageStatus: action.payload
            }
        default:
            return state;
    }
};
